import styles from "./Row.module.scss";

export const Row = ({ children, style }) => {
  return (
    <div style={style} className={styles.row}>
      {children}
    </div>
  );
};
